import { motion, AnimatePresence } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";

export const BannerText = ({ isFirstCampaign }) => {
  const { t } = useTranslation();

  const text = isFirstCampaign
    ? `${t("Congratulations on your first campaign!")} 🎉`
    : t("Thank you for your booking!");

  return (
    <AnimatePresence mode="wait">
      <motion.h1
        key={text}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        {text}
      </motion.h1>
    </AnimatePresence>
  );
};
